import axios from 'axios'

const namespaced = true

const state = {
  packageStatistic: null,
  totals: null,
  total: 0,
  isBusy: false,
  allDealersPackageStatistic: null
}

const actions = {
  getPackageStatistic ({ commit, state }, payload) {
    commit('setBusy', true)
    commit('setTotal')
    commit('setTotals')
    commit('setPackageStatistic')
    return new Promise((resolve, reject) => {
      const url = '/api/private/v3.0/billing/months/' + (payload.date._d.getFullYear() * 12 + (payload.date._d.getMonth() + 1)) + '/dealers/' + payload.ctm_id + '/reports/tracked-pairs-detail/'
      axios.get(url)
        .then(response => response.data)
        .then((res) => {
          commit('setBusy', false)
          commit('parsePackageStatistic', res)
          resolve('result')
        })
        .catch(error => {
          commit('setBusy', false)
          reject(error)
        })
    })
  },
  getPackageStatisticExcel ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const url = '/api/private/v3.0/billing/months/' + (payload.date._d.getFullYear() * 12 + (payload.date._d.getMonth() + 1)) + '/dealers/' + payload.ctm_id + '/reports/tracked-pairs-detail/xlsx/?id=' + payload.dealerId
      axios.get(url, { responseType: 'blob' })
        .then((response) => {
          response.date = payload.date
          commit('downloadPackageStatistic', response)
          resolve('result')
        })
        .catch(error => {
          commit('setBusy', false)
          reject(error)
        })
    })
  },
  getDetails ({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      const url = '/api/private/v3.0/billing/months/' + (payload.date._d.getFullYear() * 12 + (payload.date._d.getMonth() + 1)) + '/clients/' + payload.ctm_id + '/reports/dealer-detail-subreport/xlsx/'
      axios.get(url, { responseType: 'blob' })
        .then((response) => {
          response.name = payload.name
          response.date = payload.date
          commit('downloadDetails', response)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
  parsePackageStatistic (state, value) {
    state.packageStatistic = value.data_clients
    state.totals = value.totals
    state.total = value.total
    state.allDealersPackageStatistic = value
  },
  downloadPackageStatistic (state, value) {
    const month = () => {
      return (value.date._d.getMonth() + 1) < 10 ? '0' + (value.date._d.getMonth() + 1) : (value.date._d.getMonth() + 1)
    }
    const fileName = 'Статистика_по_пакетам_' + month() + '_' + value.date._d.getFullYear() + '.xlsx'
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      const downloadBlob = new Blob([value.data], { type: value.headers['content-type'] })
      window.navigator.msSaveOrOpenBlob(downloadBlob, fileName)
    } else {
      try {
        const downloadUrl = window.URL.createObjectURL(new Blob([value.data]), { type: value.headers['content-type'] })
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          link.remove()
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)
      } catch (error) {
        console.log(error)
      }
    }
  },
  downloadDetails (state, value) {
    const month = () => {
      return (value.date._d.getMonth() + 1) < 10 ? '0' + (value.date._d.getMonth() + 1) : (value.date._d.getMonth() + 1)
    }
    const fileName = 'Детализация_' + value.name.replace(/[&/\\#, +()$~%.'":*?<>{}]/g, '_') + '_' + month() + '_' + value.date._d.getFullYear() + '.xlsx'
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      const downloadBlob = new Blob([value.data], { type: value.headers['content-type'] })
      window.navigator.msSaveOrOpenBlob(downloadBlob, fileName)
    } else {
      try {
        const downloadUrl = window.URL.createObjectURL(new Blob([value.data]), { type: value.headers['content-type'] })
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          link.remove()
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)
      } catch (error) {
        console.log(error)
      }
    }
  },
  setBusy (state, value) {
    state.isBusy = value
  },
  setTotal (state, value) {
    state.total = 0
  },
  setTotals (state, value) {
    state.totals = null
  },
  setPackageStatistic (state, value) {
    state.packageStatistic = null
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
